/**
 * clickgen-cta-init.js
 *
 * This initializes the clickgen CTAs on slideview page once the Slideshare
 * Player controller and event manager have been initialized.
 */
(function (win) {
  var ClickgenCTA = win.slideshare_object.utils.imports('clickgen.ClickgenCTA'),
    clickgenCTA = null;

  function initClickgenCTA() {
    if ($.slideshareEventManager && $.slideshareEventManager.controller){
      clickgenCTA = new ClickgenCTA();
    } else {
      $(document).on('slideshare-player-controller:init-done', function() {
        clickgenCTA = new ClickgenCTA();
      });
    }
  }

  initClickgenCTA();
}(window));
